import { UserProfile } from '@shared/types';
import { getBrandInitials, getBrandPalette, getBrandSeed } from '@shared/domain/brand';

type BrandMarkProps = {
  profile: Pick<UserProfile, 'company' | 'firstName' | 'lastName' | 'logoDataUrl'>;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  label?: string;
};

const SIZE_CLASS: Record<NonNullable<BrandMarkProps['size']>, string> = {
  sm: 'brand-mark--sm',
  md: 'brand-mark--md',
  lg: 'brand-mark--lg',
};

export function BrandMark({ profile, size = 'md', className = '', label }: BrandMarkProps) {
  const seed = getBrandSeed(profile);
  const theme = getBrandPalette(seed);
  const initials = getBrandInitials(profile);
  const companyLabel = label || profile.company || 'INDXONE';

  return (
    <div
      className={`brand-mark ${SIZE_CLASS[size]} ${className}`.trim()}
      style={{ background: profile.logoDataUrl ? '#fff' : theme.background, color: theme.text, borderColor: theme.border }}
      aria-label={companyLabel}
    >
      {profile.logoDataUrl ? (
        <img className="brand-mark-image" src={profile.logoDataUrl} alt={companyLabel} />
      ) : (
        <span className="brand-mark-initials">{initials}</span>
      )}
    </div>
  );
}
